export default __webpack_public_path__ + "static/homepage-justadded-image-f0388363ec1fc7a3fcc171cff4011377.png";